import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initMonitoring } from "@/lib/monitoring";

// Kick off optional Sentry bootstrap — no-op unless DSN is configured and
// cookies have been accepted. Wrapped so a failure here never blocks render.
try {
  initMonitoring();
} catch (_err) {
  /* ignore */
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
